// import PalmBasic from "../../svg/adstyle.svg";
import { Ad3x4x1, Ad3x4x2, Ad3x4x3, Ad3x4x4, Ad3x4x5, Ad3x4x6, Ad3x4x7, Ad3x4x8, Ad3x4x9, Ad3x4x10, Ad3x4x11, Ad3x4x12, Ad3x4x13, Ad3x4x14, Ad3x4x15, Ad3x4x16, Ad4x3x1, Ad4x3x2, Ad4x3x3, Ad4x3x4, Ad4x3x5, Ad4x3x6, Ad4x3x7, Ad4x3x8, Ad4x3x9, Ad4x3x10, Ad4x3x11, Ad4x3x12, Ad4x3x13, Ad4x3x14, Ad4x3x15, Ad4x3x16, Ad4x3x17} from "../Images.js";
import sample from 'lodash/sample';
// import EmptyBox from './../../svg/box-power-down.svg';

let allAds = [Ad3x4x1, Ad3x4x2, Ad3x4x3, Ad3x4x4, Ad3x4x5, Ad3x4x6, Ad3x4x7, Ad3x4x8, Ad3x4x9, Ad3x4x10, Ad3x4x11, Ad3x4x12, Ad3x4x13, Ad3x4x14, Ad3x4x15, Ad3x4x16, Ad4x3x1, Ad4x3x2, Ad4x3x3, Ad4x3x4, Ad4x3x5, Ad4x3x6, Ad4x3x7, Ad4x3x8, Ad4x3x9, Ad4x3x10, Ad4x3x11, Ad4x3x12, Ad4x3x13, Ad4x3x14, Ad4x3x15, Ad4x3x16, Ad4x3x17];
let zIndex = 20000;
let index = 0;
const prefix = "CLICKER_";

const randomLane = () => Math.floor(1 + Math.random() * 4);
const randomvTranslate = () => -(Math.floor(Math.random() * 10) * 70);
const randomvRotate = () => Math.floor(Math.random() * 4 * ( Math.random() > 0.5 ? 1 : -1 ));

const scoreValue = () => Math.floor(Math.random() * 500) + 500

const createClickerPattern = (
	speed = 5,
	lane = randomLane(),
	vTranslate = randomvTranslate(),
	vRotation = randomvRotate(),
	value = scoreValue()
) => {
	return {
		animationDuration: speed,
		lane,
		vTranslate,
		vRotation,
		value,
		image: sample(allAds), // Ad3x4x1,
		id: prefix + index++,
		z: zIndex--
	};
};

export { createClickerPattern };



// WEBPACK FOOTER //
// ./src/components/darkpatterns/createPatterns.js